import React, { useState, useEffect, useRef, Fragment } from "react";
import { Dialog, Transition } from '@headlessui/react'
import { useDispatch } from 'react-redux'
import {useTranslation} from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBooks } from '@fortawesome/pro-light-svg-icons/faBooks';
import { faQuestion } from "@fortawesome/pro-solid-svg-icons/faQuestion";
import _ from "lodash";
import { getHelpUrl } from "../../actions/actionSystemInfo";
import classNames from "classnames";
import { faCircleNotch } from "@fortawesome/pro-light-svg-icons/faCircleNotch";


export default function Help(props) {
    const dispatch = useDispatch()
    const { t } = useTranslation('common');
    const [open, setOpen] = useState(false)
    const { title, kb, suffix, helpExtra, inline, helpHover } = props
    const [kbUrl, setKbUrl] = useState('https://kasmweb.com/docs/latest/admin_guide.html')
    const [kbVideo, setKbVideo] = useState(null)
    const [kbUrlChecked, setKbUrlChecked] = useState(false)

    const getKbUrl = async(kb) => {
      let url = kb
      if (suffix) {
        url = url + suffix
      }
      try {
        let request = await dispatch(getHelpUrl({ kb: url }))
        if (request.response.url) {
          setKbUrl(request.response.url)
        }
        if (props.video) {
          let video = await dispatch(getHelpUrl({ kb: props.video }))
          if (video.response.url && !video.response.error_message) {
            setKbVideo(video.response.url)
          }
        }
      } catch (err) {
      }
      setKbUrlChecked(true)
    }

    useEffect(() => {
      if (inline) {
        getKbUrl(kb)
      }
    }, []);

    useEffect(() => {
      if (open && !kbUrlChecked) {
        getKbUrl(kb)
      }
    }, [open]);

    let translationPrefix = 'help.'
    let kbVal = kb

    const fullKb = translationPrefix + kbVal

    return (
        <React.Fragment>
            {inline && (
                <React.Fragment>
                    <div className="text-muted tw-text-xs tw-mt-3">{t(fullKb)} <a target="_blank" href={ kbUrl }>{t('help.learn-more')}</a></div>
                </React.Fragment>
            )}
            {!inline && (
                 <React.Fragment>
                    <div onClick={(e) => { setOpen(true); e.preventDefault(); e.stopPropagation(); }} className={"tw-flex tw-h-6 tw-items-center tw-justify-center tw-pl-2"}>
                            <span className={classNames(
                              "tw-flex tw-h-4 hover:tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded hover:tw-rounded-full tw-transition-all tw-cursor-pointer tw-shadow-inner tw-bg-black/10 hover:tw-scale-125 !tw-text-white",
                              helpHover ? helpHover : "hover:!tw-bg-blue-500 hover:!tw-border-blue-500")}><FontAwesomeIcon size="xs" icon={faQuestion} /></span>
                        </div>
                    <Modal open={open} setOpen={setOpen} title={title} kb={fullKb} video={kbVideo} helpExtra={helpExtra} kbUrl={kbUrl} kbUrlChecked={kbUrlChecked} />
                </React.Fragment>
            )
        }  
        </React.Fragment>
    )
}

export function Modal(props) {
    const cancelButtonRef = useRef(null)
    const { t } = useTranslation('common');

    const { open, setOpen, title, kb, video, helpExtra, kbUrl, kbUrlChecked } = props;

    return (
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="tw-relative tw-z-[9999999]" initialFocus={cancelButtonRef} onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="tw-ease-out tw-duration-300"
            enterFrom="tw-opacity-0"
            enterTo="tw-opacity-100"
            leave="tw-ease-in tw-duration-200"
            leaveFrom="tw-opacity-100"
            leaveTo="tw-opacity-0"
          >
            <div className="tw-fixed tw-inset-0 tw-bg-gray-500 tw-bg-opacity-75 tw-transition-opacity" />
          </Transition.Child>
  
          <div className="tw-fixed tw-inset-0 tw-z-[9999999] tw-overflow-y-auto">
            <div className="tw-flex tw-min-h-full tw-items-end tw-justify-center tw-p-4 tw-text-center sm:tw-items-center sm:tw-p-0">
              <Transition.Child
                as={Fragment}
                enter="tw-ease-out tw-duration-300"
                enterFrom="tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95"
                enterTo="tw-opacity-100 tw-translate-y-0 sm:tw-scale-100"
                leave="tw-ease-in tw-duration-200"
                leaveFrom="tw-opacity-100 tw-translate-y-0 sm:tw-scale-100"
                leaveTo="tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95"
              >
                <Dialog.Panel className={classNames("tw-relative tw-transform tw-overflow-hidden tw-rounded-lg tw-bg-[var(--modal-bg)] tw-px-4 tw-pb-4 tw-pt-5 tw-text-left tw-shadow-xl tw-transition-all sm:tw-my-8 sm:tw-w-full sm:tw-p-6", video ? "sm:tw-max-w-3xl" : "sm:tw-max-w-lg")}>
                  <div>
                    <div className="tw-text-left">
                      <Dialog.Title as="h3" className="tw-text-base tw-font-semibold tw-leading-6 tw-text-gray-900 dark:tw-text-gray-100 tw-flex tw-items-center">
                        <div className={"tw-flex tw-h-10 tw-w-10 tw-mr-3 tw-items-center tw-justify-center tw-rounded-full tw-bg-blue-500 tw-text-white"}>
                            <FontAwesomeIcon icon={faBooks} />
                        </div>

                        {title || ''}
                      </Dialog.Title>
                      <div className="tw-mt-4">
                        <p className="tw-text-sm tw-text-gray-500 dark:tw-text-gray-300" dangerouslySetInnerHTML={{__html: t(kb) }}>
                        </p>
                      </div>
                      {video && video !== null && (
                        <React.Fragment>
                        <div className="tw-mt-4 tw-pb-[56.25%] tw-overflow-hidden tw-relative tw-h-0">
                          <iframe
                            width="853"
                            height="480"
                            src={video}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Video"
                            className="tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full"
                          />
                        </div>
                        <div className="tw-mt-2 tw-text-center tw-italic tw-text-xs">{ t(video) }</div>
                        </React.Fragment>
                      )}
                      {helpExtra && (
                        <div className="tw-mt-4" onClick={() => setOpen(false)}>{helpExtra}</div>
                      )}
                    </div>
                  </div>
                  <div className="tw-mt-5 sm:tw-mt-6 sm:tw-grid sm:tw-grid-flow-row-dense sm:tw-grid-cols-2 sm:tw-gap-3">
                    <a
                      href={ kbUrl }
                      className={"actionbutton tw-bg-blue-500 hover:tw-text-white hover:tw-no-underline tw-flex-col tw-justify-center tw-items-center tw-group tw-relative tw-overflow-hidden"}
                      onClick={() => {
                        // onAction(action, current)
                        setOpen(false)
                      }}
                      target="_blank"
                    >
                      {!kbUrlChecked && <span className=""><FontAwesomeIcon icon={faCircleNotch} spin /></span>}
                      {kbUrlChecked && <span className="group-hover:-tw-translate-y-2 tw-transition-all">{t('help.learn-more')}</span>}
                      <span className="tw-scale-0 tw-absolute tw-transition-all -tw-bottom-6 tw-translate-y-0 group-hover:-tw-translate-y-7 group-hover:tw-scale-100 tw-font-light tw-text-xs ">{t('help.external-link')}</span>
                    </a>
                    <button
                      type="button"
                      className="cancelbutton"
                      onClick={() => setOpen(false)}
                      ref={cancelButtonRef}
                    >
                      {t('help.cancel')}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    )
  
  }
  